import { useSelector } from 'react-redux';
import { RootState } from '../../store/redux/rootState';
import PropertyManager from '../../utils/propertyManager';

const useGetUser = () => {
  try {
    const currentUser = useSelector((state: RootState) => state.user);
    if (currentUser && PropertyManager.isDefined(currentUser)) {
      return currentUser;
    }
  } catch (error) {
    console.error('useGetUser failed:', error);
  }
  return null;
};

export default useGetUser;
